
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface WaterMeterReadingsProps {
  device: any;
}

const WaterMeterReadings: React.FC<WaterMeterReadingsProps> = ({ device }) => {
  // Ensure readings exist before accessing them
  const readings = device?.readings || {};
  
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Meter Readings</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Pressure</p>
            <p className="text-lg font-bold">{readings.pressure || 0} kPa</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Flow Rate</p>
            <p className="text-lg font-bold">{readings.flowRate || 0} L/min</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Temperature</p>
            <p className="text-lg font-bold">{readings.temperature || 0} °C</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">pH Level</p>
            <p className="text-lg font-bold">{(readings.phLevel || 0).toFixed(1)}</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Total Volume</p>
            <p className="text-lg font-bold">{(readings.totalVolume || 0).toFixed(1)} m³</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default WaterMeterReadings;
